<script>
    import BlogSummary from '../components/BlogSummary.svelte';

    export let short = false;
    export let blogUrl = "minimipanoksella_maksimitulos";
    let title = "Minimipanoksella maksimi hyöty";
    let author = "Markus";
    let blogDate = "22.10.2024";
    let titlePic = "2024/kyykky.jpg";
    let firstPara = "Tulokset tulevat nousujohteisesti kasvavan treenikuorman kautta. Nousujohteisuutta on hankala pitää yllä, jos heti ensimmäisestä sessiosta lähtien on vedetty urku auki.";
</script>

<!-- Yhteenveto (etusivu ja blogitesktisivu) -->
{#if short}
    <BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate}
                 firstPara={firstPara}></BlogSummary>

    <!-- Artikkeli -->
{:else}
    <div class="blog page">
        <article class="container">
            <h1>Minimipanoksella maksimi hyöty</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>


            <p>Salitreenin tuomat tulokset, kuten lihaskasvu ja voiman lisääntyminen, riippuvat pääosin kolmesta hyvin
                tutusta seikasta: treenistä, levosta ja ravinnosta. Tässä kirjoituksessa otetaan kantaa kahteen
                ensimmäiseen eli treeniin ja lepoon.
            </p>

            <p> Olen salilla seurannut satojen ihmisten treenaamista jo yli kymmenen vuotta ja uskallan jo sanoa, että
                monella menee harjoittelun suhteen asiat pieleen jo heti ensimmäisestä treenistä lähtien. </p>

            <p>Ensimmäisellä treenikerralla on nimittäin helppo tehdä liikaa ja liian kovaa omaan palautumiskykyyn
                verrattuna. Treenin kovuus pitäisi olla aina suhteessa omaan palautumiskykyyn, jotta keholle annetaan
                mahdollisuus kehittyä.
            </p>

            <h2>Progressiopolku</h2>

            <p>Pitkässä juoksussa tulokset tulevat nousujohteisesti kasvavan treenikuorman kautta. Nousujohteisuutta on
                hankala pitää yllä, jos heti ensimmäisestä sessiosta lähtien on vedetty täysillä. “Urku auki”, “Läpi
                harmaan kiven” ja “No pain, no gain” mentaliteetti ei toimi kovin pitkään. Maksimilla tehtyjä treenejä
                on vaikea vetää kovempaa. Ratkaisuna on enää lisätä treenikertojen määrää. Siinäkin loppuu viikosta
                äkkiä päivät, ellei palautumiskyky laita siihen rajoituksia jo aiemmin.
            </p>
            <p>Joten mikäli olet treenitaipaleesi alussa ja haluat saada kunnolla tuloksia, aloita himmailu heti.
            </p>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/2024/ampari.jpg')"></div>

            <h2>Kokkikoulu - Annos on sopiva, jos jää vähän nälkä</h2>

            <p>Yksittäistä treeniä kannattaakin ajatella enemmänkin annoksena. Mikä on minimiannos treeniä, joka silti
                vielä kehittää? Sitä on vaikea löytää, ellei aloita tarpeeksi pienestä. Esimerkiksi vasta-alkajalle
                riittää aivan mainiosti kolmesti viikossa 20 minuutin treeni. Näin kevyesti ja pienellä annoksella
                aloittaen saavutetaan seuraavia hyötyjä:
            </p>
            <ol>
                <li>Kun annos on pieni, treenin jälkeen on vielä hieman voimia ja nälkä treenin tekemiselle kasvaa.</li>
                <li>Kun annos on pieni, siihen on helpompi sitoutua. Säännölliseen treenirytmiin pääsee paremmin kiinni.
                </li>
                <li>Kun annos on pieni, kroppa ehtii tottua kuormaan, eikä jumeja ja kipuja synny niin helposti.
                </li>
                <li>Kun annos on pieni, aikaa jää muuhunkin elämään.</li>
            </ol>

            <p>Kolme lyhyttä treenikertaa viikossa on helppo monistaa neljään tai viiteen viikottaiseen treeniin.
                Treenin pituutta on myös helppo lisätä 20 -> 30 min ja samalla antaa kropan tottua uuteen rasitukseen.
            </p>

            <p>Tällä tavalla hiljalleen treeniannoksen kokoa nostamalla voidaan vielä vuosienkin päästä helposti säätää
                treenin nousujohteisuutta ja näin auttaa kehoa kehittymään. </p>
            <p>Täysillä aloittamalla tulokset tulevat toki alussa nopeammin kuin mahdollisimman pienellä annoksella,
                mutta myös kehittymisen seinät ja katto tulevat vastaan ennakoitua nopeammin.</p>
            <p>Kropan suorituskyky laskee aina treenin vaikutuksesta ja palautuu ennalleen tai jopa edellisen
                suorituskyvyn ohi, kun levätään. Tätä kutsutaan superkompensaatioksi. Alla olevassa kuvassa on
                hahmoteltu liian kovan treenin vaikutuksia.
                Superkompensaatio eli ylikorjaus, joka tarkoittaa kuormituksen aikaansaamaa sopeutumisreaktiota, jossa
                elimistö pyrkii sopeutumaan harjoituksen jälkeen tasapainotilan järkkymiseen palauttamalla tilanteen
                ennalleen.
            </p>
            <img src="/svelte-site/img/blog/2024/liiankovatreeni_nok.jpg" alt="">
            <p>Jos treenit ovat jatkuvasti liian kovia tai toistuvat liian usein omaan palautumiskykyyn verraten, niin
                elimistö ei missään vaiheessa pääse palautumaan ja korjaamaan itsestään vahvempaa.</p>
            <p>Alla olevaan kuvaan olen hahmotellut ideaalitilanteen, jossa treeniannoksen koko on sopiva suhteessa
                palautumiskykyyn ja uusi treeni / useamman treenin blokki tehdään vasta, kun elimistö on valmis ottamaan
                rasituksen vastaan.
            </p>
            <img src="/svelte-site/img/blog/2024/Superkompensaatio_ok.jpg" alt="">
            <h2>Entä kokeneemmat treenaajat? </h2>
            <p>Samaa periaatetta voi hyödyntää, vaikka treenivuosia olisi takana kymmeniä. Nimittäin vuosien
                treenaamisenkin jälkeen kehittyminen on edelleen aivan mahdollista. Se pitää tehdä vain täsmälleen saman
                “minimipanos - maksimitulos” -mentaliteetin kautta.
            </p>
            <p>Otetaan esimerkiksi kokenut treenaaja, joka treenaa neljä kertaa viikossa ja haluaa erityisesti kehittyä
                takakyykyssä. Ainoa vaihtoehto ei ole siis lisätä viidettä treeniä viikkoon vaan jo olemassa olevat
                treenikerrat voidaan suunnitella niin, että niissä priorisoidaan kyykkyä.</p>
            <p>Aloittaisin lisäämällä lämmittelyyn muutamia räjähtäviä nopeusvoimaa parantavia harjoitteita, kuten
                hyppyjä ja muita plyometrisiä harjoitteita. Ja koska hermoston toiminta ja kropan räjähtävyys on
                kokonaisuus, voi treeneihin lisätä myös erilaisia heittoja ja nopeita kiertoharjoitteita.</p>
            <p>Kyykyssä tarvitaan myös vahvaa keskivartoa, joten erilaiset keskivartaloliikkeet voidaan ottaa myös
                erityistarkasteluun.
            </p>
            <p>Tämän kaiken huomioiminen ei tarkoita, että treenit venyisivät puolella tunnilla, jotta kaiken saisi
                mahdutettua mukaan. Vaan minimipanos -ajattelutavan mukaan lähdetään liikkeelle siitä, että kahteen
                viikkotreeniin otettaisiin lämmittelyyn mukaan muutama lyhyt sarja plyometrisiä harjoitteita ja
                katsottaisiin, miten kroppa reagoi ja toimittaisiin sen mukaan. Kropan totuttua muutamaan sarjaan
                katsotaan, olisiko tilaa ja mahdollisuuksia lisätä niiden intensiteettiä tai määrää.
            </p>
            <h2>Ryhmätuntien pitäjän näkökulma minimipanokseen</h2>
            <p>Ehdotan tosi monelle vasta-alkajalle käymistä meidän ryhmätunneilla. Ryhmätunnit ovat hauskoja,
                vaihtelevia ja siellä oppii treenaamisesta enemmän kuin ikinä yksin. Monille meidän ryhmätreenit ovatkin
                ensimmäinen kosketus toiminnalliseen treeniin. Niillä on kuitenkin varjopuoli.
            </p>
            <p>Kavereiden kanssa tai porukassa touhutessa treeniannoksesta tulee herkästi aivan liian kova. Jos aloittaa
                liian kovaa, seinä tulee kehittymisen suhteen liian äkkiä vastaan. Niinpä onkin aivan ok ja erittäin
                suositeltavaa aloittaa laiskasti himmaillen!</p>
            <p>Täysillä ehtii kyllä treenaamaan sitten myöhemmin.</p>
            <p>Alkuun treeneissä onkin tärkeintä, että ne ovat hauskoja, vaihtelevia ja säännöllisiä. Treenin kovuutta
                voi lisätä sitä mukaan, kun keho tottuu rasitukseen ja kehitystä ei enää huomaa. Silloinkin on hyvä
                lisätä kuormaa vain vähän ja odotella taas uusia tuloksia.
            </p>
            <p>Kasvata siis annoskokoa hiljalleen ja malta sen jälkkärin kanssa!
            </p>
            <p>Nähdäänpä salilla!
            </p>
            <p>-Markus</p>


        </article>


        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='miten-tehda-treenaamisesta-hauskaa'
                                 title='Miten tehdä treenaamisesta hauskaa?' titlePic='dynamopaidat.jpg' blogDate=''
                                 firstPara='Salilla on kiva käydä ja siitä tulee keskimäärin mukavampaa, jos siellä kehittyy. Eikö vain?'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='juoksuvoimaa_lihaskuntoharjoittelusta'
                                 title='Juoksuvoimaa lihaskuntoharjoittelusta' titlePic='2018/juoksutreenit.jpg'
                                 firstPara='Lihasten toimintakyky on kestävyyslajeissa oleellisessa roolissa ja vahva jaksaa pidemmälle. Voimaa tarvitaan niin eteenpäin vievään liikkeeseen kuin hyvän ryhdin ylläpitämiseen.'
                                 blogDate=''></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='treenimotivaatio' title='Minne menit, treenimotivaatio?'
                                 titlePic='2016/renkaat.jpg'
                                 firstPara='Treenimotivaatio on tärkeä elementti harjoittelun aloittamisen, mutta etenkin jatkamisen kannalta. Mistä löytää kadonnut motivaatio säännöllisen harjoittelun jatkamiseksi?'
                                 blogDate=''></BlogSummary>
                </article>
            </div>
        </section>


    </div>
{/if}

<style>


</style>
